import { combineReducers } from 'redux';

import kanbanData from './kanban.reducer';
import loanPipelineEntities from './loanPipelineEntities.reducer';
import loanPipelinesData from './loanPipelines.reducer';
import pipelineStats from './pipelineStats.reducer';

const reducer = combineReducers({
  loanPipelinesData,
  loanPipelineEntities,
  kanbanData,
  pipelineStats,
});

export default reducer;
